import AuthService from "Lib/API/Auth";
import MemberService from "Lib/API/Member";
import {
  getLocalStorageRegistration,
  setLocalStorageDateRange,
  setLocalStorageRegistration,
} from "_metronic/_helpers";
import moment from "moment";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { Class } from "services/api/class";
// import ClassInfo from '../ClassInfo/ClassInfo';
import { setLocalizationMoment } from "helper/dateFormat";
import ClassInfo from "./SchoolComponents/ClassInfo/ClassInfo";
import { Spinner } from "./Theme";
export const School = () => {
  const params = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [isloading, setIsLoading] = useState(false);
  const [classDetailsLoading, setClassDetailsLoading] = useState(true);
  const [coverImage, setCoverImage] = useState(null);
  const dispatch = useDispatch();
  const Logo = localStorage.getItem("logoImgSchool");
  const token = localStorage.getItem("token");

  const calculateYearsBetwenAgeRanges = (StartYear, EndYear) => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - StartYear;
    const endYear = currentYear - EndYear;
    setLocalStorageDateRange({
      startDate: `12-31-${startYear}`,
      endDate: `01-01-${endYear}`,
    });
  };
  const getClasseById = async (Token) => {
    setIsLoading(true);
    setClassDetailsLoading(true);
    try {
      const res = await MemberService.getClassById(Token, params?.id);
      setCoverImage(res?.result?.background || "");
      dispatch(Class.actions.setClassDetails(res?.result));
      setLocalStorageRegistration({
        activeStep: getLocalStorageRegistration()?.activeStep,
        registerFormId: res?.result?.form,
        RegisterData: getLocalStorageRegistration()?.RegisterData,
        RegisterRequiredFelids: getLocalStorageRegistration()
          ?.RegisterRequiredFelids,
        classDetails: res?.result,
      });
      if (res?.result?.class_pricing?.prices.length > 0) {
        const products = res?.result?.class_pricing?.prices?.filter((item) => {
          if (item?.type === "optional") {
            return item;
          }
        });
        const varients = [];
        let varientCapacity = 0;
        // Add New Fiels to variantInfo to manage products counter
        const productRest = products?.map((val) => {
          if (val?.variant) {
            const variantInfodata =
              val?.variantInfo &&
              Object.keys(val?.variantInfo).map((key) => ({
                [key]: {
                  ...val.variantInfo[key],
                  counterValue: 0,
                  selectedValue: "",
                },
              }));
            const variantsInfo =
              val?.variantInfo &&
              Object.keys(val?.variantInfo).map((key) => {
                varientCapacity += val.variantInfo[key]?.quantity;
                return {
                  option: key,
                  counterValue: 0,
                  selectedValue: "",
                  ...val.variantInfo[key],
                };
              });
            varients.push({
              variantsInfo: variantsInfo,
              varientCapacity: isNaN(varientCapacity)
                ? "noLimit"
                : varientCapacity,
              numberOfDrops: 0,
              varientTitle: val.title,
              id: val._id,
              type: val?.type,
            });
            varientCapacity = 0;
            return {
              ...val,
              variantInfo: variantsInfo,
              counter: 0,
              dropdowns: [],
            };
          } else {
            varients.push({
              numberOfDrops: 0,
              quantity: 0,
              varientCapacity: !val.infiniteQuantity ? val.quantity : "noLimit",
              counterValue: 0,
              variantsInfo: [],
              varientTitle: val.title,
              id: val._id,
              amount: val.amount,
              type: val?.type,
            });
            return { ...val, counter: 0, dropdowns: [] };
          }
        });
        localStorage.setItem("originVarients", JSON.stringify({ ...varients }));
        dispatch(Class.actions.setVarients({ ...varients }));
        dispatch(Class.actions.resetAction([]));
        dispatch(Class.actions.setProducts(productRest));
      }
      calculateYearsBetwenAgeRanges(
        res?.result?.class_details?.ageStart,
        res?.result?.class_details?.ageEnd
      );
      const startDateDiff = moment().diff(
        moment(res?.result?.class_start_date),
        "days"
      );
      const endDateDiff = moment().diff(
        res?.result?.class_end_date
          ? moment(res?.result?.class_end_date)
          : moment(),
        "days"
      );
      if (!res?.result?.allow_non_members_register && !token) {
        enqueueSnackbar("This class is available exclusively for members", {
          variant: "error",
        });
      } else if (endDateDiff > 0) {
        enqueueSnackbar(
          "This class is no longer available due to its expiration date",
          {
            variant: "error",
          }
        );
      } else if (startDateDiff < 0) {
        enqueueSnackbar(
          `This class has not yet begun. Please check back closer to the start date for access`,
          {
            variant: "error",
          }
        );
      }
    } catch (error) {
      enqueueSnackbar(error?.data?.message, {
        variant: "error",
      });
      dispatch(Class.actions.setClassDetails({}));
    } finally {
      setIsLoading(false);
      setClassDetailsLoading(false);
    }
  };
  const generateToken = async () => {
    setIsLoading(true);
    const subDomain = window.location.hostname.split(".")[0];
    const hostName = subDomain === "localhost" ? (process.env.REACT_APP_LOCAL_ORGKEY || "stagerms") : subDomain;
    try {
      const res = await AuthService.generateToken(hostName);
      localStorage.setItem(
        "paymentMethodSchool",
        JSON.stringify(res?.paymentMethodCreditCard)
      );
      localStorage.setItem(
        "achPaymentMethodSchool",
        JSON.stringify(res?.paymentMethodAch)
      );
      localStorage.setItem("schoolToken", res?.token);
      localStorage.setItem("schoolOrgId", res?._id);
      localStorage.setItem("logoImgSchool", res?.logoImg);
      localStorage.setItem("orgName", res?.orgName);
      localStorage.setItem("country", JSON.stringify(res?.country || {}));
      localStorage.setItem("memberPortal", res?.memberPortal || false);
      localStorage.setItem(
        "allowInstallments",
        res?.allowInstallments || false
      );

      setLocalizationMoment(res?.country?.local || "en");
      document.title = `${res?.orgName}`;

      getClasseById(res?.token);
    } catch (error) {
      enqueueSnackbar(error?.data?.message, {
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    generateToken();
  }, []);

  useEffect(() => {
    dispatch(Class.actions.setProducts([]));
    localStorage.removeItem("redirectUrl");
  }, []);
  return (
    <>
      {isloading ? (
        <Spinner>
          <PulseLoader color={"#2555EF"} size={"30px"} />
        </Spinner>
      ) : (
        <ClassInfo />
      )}
    </>
  );
};
